import { AemetHistory } from "./../types/aemet.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";

export const getLastData = (aemetId: string): Promise<AemetHistory> => {
  return axios.get(`/aemetHistory/${aemetId}`).then(responseHandlerDefault);
};
